import React from 'react'
import { FacebookRounded, Instagram, LocationOn, SupportAgentRounded, ShareRounded, Twitter } from '../../utils/constants'

import './contactAddressInfo.css'

const ContactAddressInfo = () => {

  return (
    <>
        <div className='contact-address-info'>
          <div className='contact-main-info-container'>
            <div className='contact-main-info-contact-details-wrapper'>
              <div className='contact-main-info-details'>
                <h3 className='contact-main-info-title'><LocationOn /> Address</h3>
                <div className='contact-main-info-details-block'>
                    <div className='contact-main-info-text'>12, dublin road, Ikeja Lagos</div>
                </div>
              </div>
              <div className='contact-main-info-details'>
                <h3 className='contact-main-info-title'><SupportAgentRounded /> Support</h3>
                <div className='contact-main-info-text'>+234 111 1111 <br/> sample@email</div>
              </div>
              <div className='contact-main-info-details'>
                <h3 className='contact-main-info-title'><ShareRounded />Social Media</h3>
                <ul className="contact-us__socials">
                    <li><a className='contact-us__socials_link' href={`https://facebook.com/hexagon-konnect`} target='_blank' rel="noreferrer"><span><FacebookRounded /></span></a></li>
                    <li><a className='contact-us__socials_link' href={`https://instagram.com/hexagon-konnect`} target='_blank' rel="noreferrer"><span><Instagram /></span></a></li>
                    <li><a className='contact-us__socials_link' href={`https://twitter.com/hexagon-konnect`} target='_blank' rel="noreferrer"><span><Twitter /></span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default ContactAddressInfo